export interface ProductVariant {
  id: string;
  colorName: string;
  hexColor: string;
  rgbColor: string;
  stock: number;
  images: string[];
}

export interface StoreProduct {
  id: string;
  name: string;
  description: string;
  price: number;
  regularPrice?: number | null;
  discountedPrice?: number | null;
  discountType?: "FIXED_PRICE" | "PERCENTAGE" | null;
  discountPercentage?: number | null;
  showDiscountRibbon?: boolean;
  discountRibbonText?: string | null;
  stock: number;
  images: string[];
  primaryImage?: string | null;
  variants?: ProductVariant[] | null;
  category: string;
  isFeatured?: boolean;
}

export const getProductPricing = (product: StoreProduct) => {
  const regularPrice = Number(product.regularPrice ?? product.price);
  const discountedPrice = product.discountedPrice == null ? null : Number(product.discountedPrice);
  const hasDiscount = discountedPrice !== null && discountedPrice > 0 && discountedPrice < regularPrice;
  return {
    regularPrice,
    discountedPrice: hasDiscount ? discountedPrice : null,
    payablePrice: hasDiscount ? discountedPrice : Number(product.price ?? regularPrice),
    hasDiscount,
  };
};

export const getPrimaryProductImage = (product: StoreProduct) => product.primaryImage || product.images?.[0] || "";

export const getProductSlug = (name: string) => {
  const slug = name
    .normalize("NFKC")
    .trim()
    .toLocaleLowerCase("en")
    .replace(/&/g, " and ")
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 100)
    .replace(/-+$/g, "");

  return slug || "product";
};

export const getProductPath = (product: Pick<StoreProduct, "id" | "name">) =>
  `/products/${getProductSlug(product.name)}/${product.id}`;

export const getDiscountRibbonText = (product: StoreProduct) => {
  if (product.discountRibbonText?.trim()) return product.discountRibbonText.trim();
  if (product.discountType === "PERCENTAGE" && product.discountPercentage) {
    return `${Number(product.discountPercentage)}% OFF`;
  }
  const { regularPrice, discountedPrice } = getProductPricing(product);
  if (discountedPrice !== null) {
    const amount = Math.round((regularPrice - discountedPrice) * 100) / 100;
    return `BDT ${amount.toLocaleString("en-BD")} OFF`;
  }
  return "Special Offer";
};
